'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

var useOverlayOutsideClick = function (onClickOutside, propagateOutsideClicks) {
    if (propagateOutsideClicks === void 0) { propagateOutsideClicks = false; }
    var ref = React.useRef(null);
    React.useEffect(function () {
        var handleClickOutside = function (event) {
            if (ref.current && event.target && !ref.current.contains(event.target)) {
                if (!propagateOutsideClicks) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                onClickOutside();
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    return ref;
};

exports.default = useOverlayOutsideClick;
//# sourceMappingURL=index.js.map
